import { StorageSerializers, useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed } from 'vue';
import type { CompanyJson } from '@/data/companies/CompanyJson.ts';
import Company from '@/domain/model/business/Company.ts';

const COMPANY_KEY = 'company';

export const useCompanyStore = defineStore('company', () => {
  const companyJson = useLocalStorage<CompanyJson | null>(COMPANY_KEY, null, {
    serializer: StorageSerializers.object,
  });

  const company = computed<Company | null>(() =>
    companyJson.value ? Company.fromJson(companyJson.value) : null,
  );

  function set(newCompany: CompanyJson): void {
    companyJson.value = newCompany;
  }

  function clear(): void {
    companyJson.value = null;
  }

  return { company, set, clear };
});
